import { Injectable } from '@angular/core';
import { ServerPath } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, switchMap, debounceTime, take, retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { pipe, timer, throwError, Observable, of } from 'rxjs';
import { User } from '../data-models/user.class';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

    private loggedIn = false;
    private authData: {};
    authServer =  ServerPath;
    user:User;

    constructor(private http: HttpClient) {
        if (localStorage.getItem('authData')) {
            const authInfo = JSON.parse(localStorage.getItem('authData'));
            // console.log(authInfo);
            this.authData = authInfo;
            this.loggedIn = true;
            this.user = JSON.parse(localStorage.getItem('userInfo'));
            // console.log('is login status on authservice constructor', this.loggedIn);
        } else {
            this.loggedIn = false;
        }
    }


    isLoggedIn() {
        return this.loggedIn;
    }

    
    currentUserValue() {
        this.user = JSON.parse(localStorage.getItem('userInfo'));
        return this.user;
    }    

     login(email, password) {
        const headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/x-www-form-urlencoded');
        // headers.append('Authorization', 'Basic SVRXRV9NT0JJTEVfQVBQOml0d2VfY2xpZW50');
        let menuArr:any=[];
        let user: any = {};
        const data$ =   this.http.post(this.authServer.auth + 'login/' , 
        {email, password }, { headers }).pipe(map(res =>{ user = res; return res}));

        return data$.mergeMap(res =>
                this.http.post<any[]>(this.authServer.roleMenuMapping +'getMenuByRole' ,JSON.stringify({'role': res['user']['role']}) , { headers })
                .pipe(
                    map(res => {
                        if (res) {
                      //  console.log('---menu role details----',JSON.stringify(res));
                      
                            if(user['user']['isLicensee']==1) {
                                res.forEach(menu => {
                                    menu.Menu['children']='null';
                                    const dashBArr = ["dashboard", "technician", "shoppingcart", "search","pp-purchase-order"];
                                    if(dashBArr.includes(menu.Menu['name'])){
                                        menuArr.push(menu.Menu);
                                    }
                                   
                                });
                            } else {
                                res.forEach(menu => {
                                    menu.Menu['children']='null';
                                    menuArr.push(menu.Menu);
                                
                                });
                            }
                            
                        }
                                 
                        const userInfo = {
                            username: user['user']['username'],
                            email: user['user']['email'],
                            role: user['user']['role'],
                            image: user['user']['image'],
                            id: user['user']['_id'],
                            role_id: user['user']['role_id'],
                            isLicenseePP : user['user']['isLicensee'] ? user['user']['isLicensee'] : 0,
                            comp_id :  user['user']['comp_id'] ? user['user']['comp_id'] : '',
                            comp_name : user['user']['comp_name'] ? user['user']['comp_name'] : '',
                            menu:menuArr
                        }
                        //console.log(userInfo);

                        const token = {
                            token : user['token']
                        }
                        this.loggedIn = true;
                        localStorage.setItem('authData', JSON.stringify(token));
                        localStorage.setItem('userInfo', JSON.stringify(userInfo));
                        return user;
                    })
                )
        )

       
    }

    forgetPassword(email) {
        const headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/x-www-form-urlencoded');
        // headers.append('Authorization', 'Basic SVRXRV9NT0JJTEVfQVBQOml0d2VfY2xpZW50');
        return this.http.post(this.authServer.auth + 'forgetPassword/' , {email }, { headers })
        .pipe(
            map(res => {
            if (res) {
                // localStorage.setItem('authData', JSON.stringify(res));
                // this.loggedIn = true;
                // console.log('is login status on from login function', this.loggedIn);
                return res;
            }
            return res;
        })
      );

    }

    resetPassword(resetToken, password) {
        const headers = new HttpHeaders();
        return this.http.post(this.authServer.auth + 'resetPassword/'   , {resetToken, password }, { headers })
        .pipe(
            map(res => {
                if (res) {
                    // localStorage.setItem('authData', JSON.stringify(res));
                    // this.loggedIn = true;
                    // console.log('is login status on from login function', this.loggedIn);
                    return res;
                }
                return res;
            })
        );
    }

    setPassword(activationToken, password) {
        //console.log(password);

        const headers = new HttpHeaders();
        return this.http.post(this.authServer.auth + 'activate/'   , {activationToken, password }, { headers })
        .pipe(
            map(res => {
                if (res) {
                    // localStorage.setItem('authData', JSON.stringify(res));
                    // this.loggedIn = true;
                    // console.log('is login status on from login function', this.loggedIn);
                    return res;
                }
                return res;
            })
        );
    }


    registerUser(user: User) {
        
        const body = JSON.stringify(user);
        //console.log(body);
        return this.http.post(this.authServer.auth + 'register/', body)
            .pipe(
                retry(3),
                catchError(this.handleError)
            )
    }

    

    refreshToken(oldToken: string) {
        const token = '';

        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        headers.append('Authorization', 'Basic SVRXRV9NT0JJTEVfQVBQOml0d2VfY2xpZW50');

        const body: any = 'grant_type=refresh_token&refresh_token=' + oldToken;
        return this.http.post(this.authServer.auth + '/token', body, {headers})
            .pipe(
                map(res => {
                if (res) {
                    localStorage.setItem('authData', JSON.stringify(res));
                    this.loggedIn = true;
                }
                return res;
            })
            );
    }

  // Log user out
    logout() {
        localStorage.removeItem('authData');
        localStorage.removeItem('userInfo');
        this.loggedIn = false;
        return;
    }

    checkEmailNotTaken(email: string) {
        return timer(0).pipe(
            debounceTime(200),
            take(1),
            switchMap(() => {
                return this.http.get(this.authServer.auth + 'checkEmail/'+email);
            })
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error);
         
            return throwError('Server not responding. please try again later.');
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error.msg}`);
          
            return throwError(error.error);
        }
        // return an observable with a user-facing error message
        
      };


    getMenuByRole(role) {
 
        const headers = new HttpHeaders();
        //console.log('connect to api');
        
        const body ={
            role:role
        };

        let menuArr:any=[];
        return this.http.post<any[]>(this.authServer.roleMenuMapping +'getMenuByRole' ,JSON.stringify(body) , { headers })
        .pipe(
            map(res => {
                if (res) {
              //  console.log('---menu role details----',JSON.stringify(res));

                    res.forEach(menu => {
                        menu.Menu['children']='null';
                    // console.log('========');
                    // console.log(menu);
                        menuArr.push(menu.Menu);
                    
                    });
                   
                }
               // return res;
                return menuArr;
            })
        );
        // return of(menuArr);
    }



}
